import {
  addKonsepTemuan,
  getListKonsepTemuan,
  getListPermindok,
  getDetailPermindok,
  editPermindok,
  addPermindok,
  addPermindokAttachment,
  getListOptionBPK,
  deletePermindokAttachment,
  getListKonsepTemuanKKP,
  getDetailKonsepTemuan,
  addFileKKP,
  addFolderKKP,
  dispositionKonsepTemuan,
  feedbackKonsepTemuan,
  getCounterBPK,
  deletePermindok,
  deleteFolderKKP,
  deleteFileKKP,
  getOptionUnkerPermindok,
  dispositionPermindok,
  patchReadFile,
  downloadAllFolder,
  getListPermindokMonitoring,
  getListKonsepTemuanMonitoring,
  getDetailPermindokMonitoring,
} from '@crema/services/apis/bpkdrive';
import {appIntl} from '@crema/utility/helper/Utils';
import {
  FETCH_ERROR,
  FETCH_SUCCESS,
  FETCH_START,
  SHOW_MESSAGE,
  ADD_KONSEP_TEMUAN,
  GET_LIST_KONSEP_TEMUAN,
  GET_LIST_PERMINDOK,
  GET_DETAIL_PERMINDOK,
  EDIT_PERMINDOK,
  ADD_PERMINDOK,
  ADD_PERMINDOK_ATTACHMENT,
  GET_LIST_OPTION_BPK,
  DELETE_PERMINDOK_ATTACHMENT,
  GET_LIST_KONSEP_TEMUAN_KKP,
  GET_DETAIL_KONSEP_TEMUAN,
  DELETE_ALL_PERMINDOK_ATTACHMENT,
  ADD_FILE_KKP,
  DELETE_KONSEP_TEMUAN_ATTACHMENT,
  DELETE_ALL_KONSEP_TEMUAN_ATTACHMENT,
  GET_COUNTER_BPK,
  ADD_FOLDER_KKP,
  DELETE_FOLDER_BPK,
  DELETE_FOLDER_KKP,
  DELETE_FILE_KKP,
  GET_OPTION_UNKER_PERMINDOK,
  PATCH_READ_FILE,
  DOWNLOAD_ALL_FOLDER,
  DELETE_PERMINDOK,
  GET_LIST_PERMINDOK_MONITORING,
  IS_MONITORING,
  GET_LIST_KONSEP_TEMUAN_MONITORING,
  GET_DETAIL_PERMINDOK_MONITORING,
  GET_SUB_DETAIL_PERMINDOK,
} from 'shared/constants/ActionTypes';

export const onGetCounterBPK = (mode) => {
  const {messages} = appIntl();
  return (dispatch) => {
    getCounterBPK(mode)
      .then((data) => {
        if (data) {
          dispatch({type: GET_COUNTER_BPK, payload: data.result});
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({type: FETCH_ERROR, payload: error.message});
      });
  };
};

// PERMINDOK //
export const onGetListPermindok = (page, search) => {
  const {messages} = appIntl();
  return (dispatch) => {
    dispatch({type: FETCH_START});
    getListPermindok(page, search)
      .then((data) => {
        if (data) {
          dispatch({type: GET_LIST_PERMINDOK, payload: data});
          dispatch({type: FETCH_SUCCESS});
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({type: FETCH_ERROR, payload: error.message});
      });
  };
};

export const onGetListPermindokMonitoring = (page, search) => {
  const {messages} = appIntl();
  return (dispatch) => {
    dispatch({type: FETCH_START});
    getListPermindokMonitoring(page, search)
      .then((data) => {
        if (data) {
          dispatch({type: GET_LIST_PERMINDOK_MONITORING, payload: data});
          dispatch({type: FETCH_SUCCESS});
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({type: FETCH_ERROR, payload: error.message});
      });
  };
};

export const onPatchReadFile = (fileId) => {
  return (dispatch) => {
    patchReadFile(fileId)
      .then((data) => {
        if (data) {
          dispatch({
            type: PATCH_READ_FILE,
            payload: data.result.id,
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: error.message,
        });
      });
  };
};

export const onGetDetailPermindok = (id) => {
  const {messages} = appIntl();
  return (dispatch) => {
    dispatch({type: FETCH_START});
    getDetailPermindok(id)
      .then((data) => {
        if (data) {
          dispatch({type: GET_DETAIL_PERMINDOK, payload: data});
          dispatch({type: FETCH_SUCCESS});
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({type: FETCH_ERROR, payload: error.message});
      });
  };
};

export const onGetSubDetailPermindok = (id) => {
  const {messages} = appIntl();
  return (dispatch) => {
    dispatch({type: FETCH_START});
    getDetailPermindok(id)
      .then((data) => {
        if (data) {
          dispatch({type: GET_SUB_DETAIL_PERMINDOK, payload: data, meta: {id}});
          dispatch({type: FETCH_SUCCESS});
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({type: FETCH_ERROR, payload: error.message});
      });
  };
};

export const onGetDetailPermindokMonitoring = (id) => {
  const {messages} = appIntl();
  return (dispatch) => {
    dispatch({type: FETCH_START});
    getDetailPermindokMonitoring(id)
      .then((data) => {
        if (data) {
          dispatch({type: GET_DETAIL_PERMINDOK_MONITORING, payload: data});
          dispatch({type: FETCH_SUCCESS});
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({type: FETCH_ERROR, payload: error.message});
      });
  };
};

export const onDownloadAllFolder = (id, name) => {
  const {messages} = appIntl();

  return async (dispatch) => {
    dispatch({type: FETCH_START});

    try {
      const {blob, headers} = await downloadAllFolder(id);

      let filename = `${name}.zip`;
      const disposition = headers.get('content-disposition');

      if (disposition && disposition.includes('filename=')) {
        filename = disposition.split('filename=')[1].replace(/"/g, '');
      }

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      dispatch({type: FETCH_SUCCESS});
    } catch (error) {
      dispatch({
        type: FETCH_ERROR,
        payload: messages['message.somethingWentWrong'],
      });
    }
  };
};

export const onAddPermindok = (data) => {
  const {messages} = appIntl();
  return (dispatch) => {
    dispatch({type: FETCH_START});
    addPermindok(data)
      .then((response) => {
        if (response) {
          dispatch({type: ADD_PERMINDOK, payload: response.result});
          dispatch({type: FETCH_SUCCESS});
          dispatch({
            type: SHOW_MESSAGE,
            payload: 'Pemintaan Dokumen Berhasil Dibuat',
          });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({type: FETCH_ERROR, payload: error.message});
      });
  };
};

export const onAddFolderKKP = (data) => {
  const {messages} = appIntl();
  return (dispatch) => {
    dispatch({type: FETCH_START});

    addFolderKKP(data)
      .then((response) => {
        if (response?.success) {
          dispatch({
            type: ADD_FOLDER_KKP,
            payload: response.result,
            meta: {parent_id: data?.[0]?.parent_id},
          });
          dispatch({type: FETCH_SUCCESS});
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({type: FETCH_ERROR, payload: error.message});
      });
  };
};

export const onDeleteFolderKKP = (id) => {
  const {messages} = appIntl();
  return (dispatch) => {
    dispatch({type: FETCH_START});
    deleteFolderKKP(id)
      .then((data) => {
        if (data) {
          dispatch({
            type: DELETE_FOLDER_KKP,
            payload: data.result,
            payload: id,
          });
          dispatch({type: FETCH_SUCCESS});
          dispatch({
            type: SHOW_MESSAGE,
            payload: 'Folder Berhasil Dihapus',
          });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({type: FETCH_ERROR, payload: error.message});
      });
  };
};

export const onDeletePermindok = (id) => {
  const {messages} = appIntl();
  return (dispatch) => {
    dispatch({type: FETCH_START});
    deleteFolderKKP(id)
      .then((data) => {
        if (data) {
          dispatch({
            type: DELETE_PERMINDOK,
            payload: data.result,
            payload: id,
          });
          dispatch({type: FETCH_SUCCESS});
          dispatch({
            type: SHOW_MESSAGE,
            payload: 'Permindok Berhasil Dihapus',
          });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({type: FETCH_ERROR, payload: error.message});
      });
  };
};

export const onAddPermindokAttachment = (file) => {
  const {messages} = appIntl();
  return (dispatch) => {
    dispatch({type: FETCH_START});
    addPermindokAttachment(file)
      .then((data) => {
        if (data) {
          dispatch({type: ADD_PERMINDOK_ATTACHMENT, payload: data.result});
          dispatch({type: FETCH_SUCCESS});
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({type: FETCH_ERROR, payload: error.message});
      });
  };
};

export const onAddFileKKP = (file, folder_id) => {
  const {messages} = appIntl();
  return (dispatch) => {
    dispatch({type: FETCH_START});
    addFileKKP(file, folder_id)
      .then((data) => {
        if (data) {
          dispatch({
            type: ADD_FILE_KKP,
            payload: data.result,
            meta: {folder_id},
          });
          dispatch({type: FETCH_SUCCESS});
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({type: FETCH_ERROR, payload: error.message});
      });
  };
};

export const onDeleteFileKKP = (id) => {
  const {messages} = appIntl();
  return (dispatch) => {
    dispatch({type: FETCH_START});
    deleteFileKKP(id)
      .then((data) => {
        if (data) {
          dispatch({
            type: DELETE_FILE_KKP,
            payload: data.result,
            payload: id,
          });
          dispatch({type: FETCH_SUCCESS});
          dispatch({
            type: SHOW_MESSAGE,
            payload: 'File Berhasil Dihapus',
          });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({type: FETCH_ERROR, payload: error.message});
      });
  };
};

export const onEditPermindok = (id, data) => {
  const {messages} = appIntl();
  return (dispatch) => {
    dispatch({type: FETCH_START});
    editPermindok(id, data)
      .then((data) => {
        if (data) {
          dispatch({type: EDIT_PERMINDOK, payload: data.result});
          dispatch({type: FETCH_SUCCESS});
          dispatch({
            type: SHOW_MESSAGE,
            payload: 'Pemintaan Dokumen Berhasil Diubah',
          });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({type: FETCH_ERROR, payload: error.message});
      });
  };
};

export const onDeletePermindokAttachment = (id) => {
  return (dispatch) =>
    dispatch({type: DELETE_PERMINDOK_ATTACHMENT, payload: id});
};

export const onDeleteAllPermindokAttachment = () => {
  return (dispatch) => dispatch({type: DELETE_ALL_PERMINDOK_ATTACHMENT});
};

export const onGetOptionUnkerPermindok = () => {
  const {messages} = appIntl();
  return (dispatch) => {
    dispatch({type: FETCH_START});
    getOptionUnkerPermindok()
      .then((data) => {
        if (data) {
          dispatch({type: GET_OPTION_UNKER_PERMINDOK, payload: data});
          dispatch({type: FETCH_SUCCESS});
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({type: FETCH_ERROR, payload: error.message});
      });
  };
};

export const onDispositionPermindok = (payload, onSuccess) => {
  const {messages} = appIntl();
  return (dispatch) => {
    dispatch({type: FETCH_START});
    dispositionPermindok(payload)
      .then((data) => {
        if (data.success) {
          dispatch({
            type: SHOW_MESSAGE,
            payload: 'Disposisi Berhasil Ditambahkan',
          });

          if (onSuccess) {
            setTimeout(() => {
              onSuccess();
            }, 1500);
          }
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({type: FETCH_ERROR, payload: error.message});
      });
  };
};

// KONSEP TEMUAN //
export const onGetListKonsepTemuan = (
  page = 0,
  tipe = 'bpk_drive',
  tipe_dokumen = 'konsep_temuan',
  general = '',
) => {
  const {messages} = appIntl();
  return (dispatch) => {
    dispatch({type: FETCH_START});
    getListKonsepTemuan(page, tipe, tipe_dokumen, general)
      .then((data) => {
        if (data) {
          dispatch({type: GET_LIST_KONSEP_TEMUAN, payload: data});
          dispatch({type: FETCH_SUCCESS});
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({type: FETCH_ERROR, payload: error.message});
      });
  };
};

export const onGetDetailKonsepTemuan = (id) => {
  const {messages} = appIntl();
  return (dispatch) => {
    dispatch({type: FETCH_START});
    dispatch({type: GET_DETAIL_KONSEP_TEMUAN, payload: null});

    getDetailKonsepTemuan(id)
      .then((data) => {
        if (data) {
          dispatch({type: GET_DETAIL_KONSEP_TEMUAN, payload: data.result});
          dispatch({type: FETCH_SUCCESS});
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({type: FETCH_ERROR, payload: error.message});
      });
  };
};

export const onAddKonsepTemuan = (payload, onSuccess) => {
  const {messages} = appIntl();
  return (dispatch) => {
    dispatch({type: FETCH_START});
    const type =
      payload.tipe_dokumen === 'administratif'
        ? 'Administratif'
        : 'Konsep Temuan';
    addKonsepTemuan(payload)
      .then((data) => {
        if (data.success) {
          dispatch({
            type: SHOW_MESSAGE,
            payload: `${type} Berhasil Ditambahkan`,
          });
          dispatch({type: ADD_KONSEP_TEMUAN, payload: data.result});

          if (onSuccess) {
            setTimeout(() => {
              onSuccess();
            }, 1500);
          }
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({type: FETCH_ERROR, payload: error.message});
      });
  };
};

export const onDispositionKonsepTemuan = (payload, onSuccess) => {
  const {messages} = appIntl();
  return (dispatch) => {
    dispatch({type: FETCH_START});
    dispositionKonsepTemuan(payload)
      .then((data) => {
        if (data.success) {
          dispatch({
            type: SHOW_MESSAGE,
            payload: 'Disposisi Berhasil Ditambahkan',
          });

          if (onSuccess) {
            setTimeout(() => {
              onSuccess();
            }, 1500);
          }
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({type: FETCH_ERROR, payload: error.message});
      });
  };
};

export const onFeedbackKonsepTemuan = (payload, onSuccess) => {
  const {messages} = appIntl();
  return (dispatch) => {
    dispatch({type: FETCH_START});
    feedbackKonsepTemuan(payload)
      .then((data) => {
        if (data.success) {
          dispatch({
            type: SHOW_MESSAGE,
            payload: 'Tanggapan Berhasil Ditambahkan',
          });

          if (onSuccess) {
            setTimeout(() => {
              onSuccess();
            }, 1500);
          }
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({type: FETCH_ERROR, payload: error.message});
      });
  };
};

export const onGetListKonsepTemuanKKP = (
  page = 0,
  tipe = 'bpk_drive',
  tipe_dokumen = 'konsep_temuan',
  general = '',
) => {
  const {messages} = appIntl();
  return (dispatch) => {
    dispatch({type: FETCH_START});
    getListKonsepTemuanKKP(page, tipe, tipe_dokumen, general)
      .then((data) => {
        if (data) {
          dispatch({type: GET_LIST_KONSEP_TEMUAN_KKP, payload: data});
          dispatch({type: FETCH_SUCCESS});
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({type: FETCH_ERROR, payload: error.message});
      });
  };
};

export const onGetListKonsepTemuanMonitoring = (
  page = 0,
  tipe = 'bpk_drive',
  tipe_dokumen = 'konsep_temuan',
  general = '',
) => {
  const {messages} = appIntl();
  return (dispatch) => {
    dispatch({type: FETCH_START});
    getListKonsepTemuanMonitoring(page, tipe, tipe_dokumen, general)
      .then((data) => {
        if (data) {
          dispatch({type: GET_LIST_KONSEP_TEMUAN_MONITORING, payload: data});
          dispatch({type: FETCH_SUCCESS});
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({type: FETCH_ERROR, payload: error.message});
      });
  };
};

export const onDeleteAttachmentKonsepTemuan = (data) => {
  return (dispatch) =>
    dispatch({type: DELETE_KONSEP_TEMUAN_ATTACHMENT, payload: data});
};

export const onDeleteAllAttachmentKonsepTemuan = () => {
  return (dispatch) => dispatch({type: DELETE_ALL_KONSEP_TEMUAN_ATTACHMENT});
};

export const onGetListOptionBPK = (
  page = 1,
  tipe = '',
  tipe_dokumen = '',
  general = '',
) => {
  const {messages} = appIntl();
  return (dispatch) => {
    dispatch({type: FETCH_START});
    getListOptionBPK(page, tipe, tipe_dokumen, general)
      .then((data) => {
        if (data) {
          dispatch({type: GET_LIST_OPTION_BPK, payload: data});
          dispatch({type: FETCH_SUCCESS});
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      })
      .catch((error) => {
        dispatch({type: FETCH_ERROR, payload: error.message});
      });
  };
};
